import {fromEvent, Observable, of} from 'rxjs';
import {SocketIoClientProvider} from './driver/socket_io_client_provider';
import {BoatProgressForRaceSocket, BoatProgressStatusUpdate} from '../business/boats/boats_progress_provider';
import {switchMap} from 'rxjs/operators';

export interface BoatsProgressSocket extends BoatProgressForRaceSocket {}

export class DefaultBoatsProgressSocket implements BoatsProgressSocket {
    constructor(private socketIoClientProvider: SocketIoClientProvider) {}

    public getForRaceId(raceId: string): Observable<BoatProgressStatusUpdate> {
        return fromEvent<BoatProgressStatusUpdate[]>(
            this.socketIoClientProvider.get(),
            `race/${raceId}/boat-progresses`,
        ).pipe(switchMap((data: BoatProgressStatusUpdate[]) => of(...data)));
    }
}
